import { graphql, useStaticQuery } from "gatsby"
// import Img from 'gatsby-image';
import PropTypes from "prop-types"
import styled from "styled-components/macro"
// import Announcement from './announcement';
// import { useMediaQuery } from 'react-responsive';
import React, { useState } from "react"
import Sidebar from "./sidebar"

const StickyDiv = styled.div`
  margin: 0 auto;
  position: sticky;
  background: ${props => props.bgCol};
  top: 0;
  z-index: 25;

  .announcement {
    padding: 0.4rem 1.0875rem;
    font-size: 1.4rem;
  }

  .nav-wrapper {
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: baseline;

    @media only screen and (min-width: 900px) {
      padding: 1.45rem 1.0875rem;
    }
  }

  .logoHeader {
    flex: 0 1 30%;
    margin-top: 0.2rem;
    margin-left: auto;

    @media only screen and (min-width: 500px) {
      flex: 0 1 20%;
    }

    @media only screen and (min-width: 900px) {
      flex: 0 1 8%;
      margin: 0;
    }
  }

  .page-nav {
    display: flex;
    align-items: center;
    justify-content: space-around;
    list-style: none;
    text-align: center;
    text-transform: uppercase;

    /* background-color: rgba(67, 114, 112, .4); */
  }

  .navToggle {
    /* flex: 0 1 8%;
     margin-left: .5rem;
     margin-top: .4rem;

     @media only screen and (min-width: 500px) {
      flex: 0 1 5%;
    } */
  }

  nav {
    flex: 0 1 60%;
    margin: 0 auto;

    li,
    a {
      text-decoration: none;
      font-size: 1.4rem;
      font-weight: 900;
      letter-spacing: 0.3rem;
      padding: 0.2rem 0.8rem;
      font-family: "Poppins", sans-serif;
      display: inline-block;
      /* background-color: #2c2c2c; */
      /* color: white; */
      color: black;
    }

    a:hover {
      color: #cc14c1;
    }

    a:active {
      color: #cc14c1;
    }
  }

  .desktop-links {
    display: none;

    @media only screen and (min-width: 900px) {
      display: block;
    }
  }

  .drawer-toggle-icon {
    display: block;
    @media only screen and (min-width: 900px) {
      display: none;
    }

    flex: 0 1 8%;
    margin-left: 0.5rem;
    margin-top: 0.4rem;

    @media only screen and (min-width: 500px) {
      flex: 0 1 5%;
    }
  }
`

const Header = props => {
  // const is900pxWide = useMediaQuery({ query: '(min-width: 900px)' });
  const [navDrawerOpen, setNavDrawerOpen] = useState(false)

  const closeNavDrawer = () => {
    setNavDrawerOpen(false)
  }

  const data = useStaticQuery(
    graphql`
      query {
        logoImage: file(relativePath: { eq: "WizWorksLogo.png" }) {
          childImageSharp {
            fluid(maxWidth: 1400) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )

  console.log(data)

  return (
    <>
      <StickyDiv bgCol="#3c3c3c">
        <div style={{ backgroundColor: "#3c3c3c" }}>
          <div className="announcement">
            <h4 style={{ margin: 0, color: "white", textAlign: "center" }}>
              Now booking for your next celebration!
            </h4>
          </div>
        </div>
        {/* </StickyDiv> */}
        {/* <StickyDiv bgCol="#fff"> */}
        <div style={{ backgroundColor: "#fff" }}>
          <div className="nav-wrapper">
            <div className="drawer-toggle-icon">
              {// !is900pxWide &&
              !navDrawerOpen && (
                <div
                  className="navToggle"
                  onClick={() => setNavDrawerOpen(true)}
                >
                  <svg
                    viewBox="0 0 52 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 5.91C0 2.645 1.663 0 3.714 0h44.572C50.337 0 52 2.646 52 5.91c0 3.263-1.663 5.908-3.714 5.908H3.714C1.663 11.818 0 9.173 0 5.91zM0 26c0-3.264 1.663-5.91 3.714-5.91h44.572C50.337 20.09 52 22.737 52 26c0 3.264-1.663 5.91-3.714 5.91H3.714C1.663 31.91 0 29.263 0 26zM0 46.09c0-3.263 1.663-5.908 3.714-5.908h44.572c2.051 0 3.714 2.645 3.714 5.909C52 49.354 50.337 52 48.286 52H3.714C1.663 52 0 49.354 0 46.09z"
                      fill="#CC14C1"
                    />
                  </svg>
                </div>
              )}
              {// !is900pxWide &&
              navDrawerOpen && (
                <div
                  className="navToggle"
                  onClick={() => setNavDrawerOpen(false)}
                >
                  <svg
                    viewBox="0 0 52 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.392 8.176C-.798 5.856-.352 2.63 2.39.969 5.132-.692 9.13-.159 11.32 2.159L50.61 43.742c2.19 2.32 1.744 5.546-.998 7.207-2.742 1.661-6.74 1.128-8.931-1.19L1.392 8.175z"
                      fill="#CC14C1"
                    />
                    <path
                      d="M40.518 2.173C42.704-.154 46.702-.697 49.45.958c2.747 1.655 3.203 4.883 1.018 7.209l-39.136 41.66c-2.186 2.327-6.184 2.87-8.932 1.215-2.747-1.655-3.203-4.883-1.018-7.209l39.136-41.66z"
                      fill="#CC14C1"
                    />
                  </svg>
                </div>
              )}
            </div>
            <div className="logoHeader">
              <svg
                viewBox="0 0 161 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M37.312 3.576l-.096-1.824c0-.576.32-.864.96-.864.96 0 1.44.976 1.44 2.928s-.624 4.784-1.872 8.496c-1.248 3.712-2.528 6.896-3.84 9.552-1.76 3.68-3.632 6.464-5.616 8.352C26.304 32.072 24.592 33 23.152 33c-1.824 0-3.168-1.104-4.032-3.312-.832-2.208-1.248-5.088-1.248-8.64 0-1.152.048-2.304.144-3.456-1.056 2.848-2.256 5.36-3.6 7.536-1.312 2.144-2.576 3.744-3.792 4.8-2.336 2.08-4.272 3.12-5.808 3.12-1.504 0-2.624-.848-3.36-2.544C.72 28.808.352 26.552.352 23.736c0-5.568 1.008-11.232 3.024-16.992-.192-.032-.288-.256-.288-.672 0-.448.272-1.2.816-2.256.544-1.088.976-1.776 1.296-2.064.608-.48 1.184-.72 1.728-.72 1.024 0 1.536.272 1.536.816 0 .16-.064.304-.192.432C7.12 3.336 6.064 5.528 5.104 8.856c-.96 3.328-1.6 6.384-1.92 9.168-.32 2.784-.48 4.896-.48 6.336 0 4.512 1.12 6.768 3.36 6.768 1.216 0 2.976-1.312 5.28-3.936 1.152-1.312 2.368-3.184 3.648-5.616 1.312-2.432 2.48-5.168 3.504-8.208.352-2.624.8-4.816 1.344-6.576-.288-.096-.432-.32-.432-.672 0-.992.352-1.776 1.056-2.352.736-.608 1.36-.912 1.872-.912s.896.096 1.152.288c.288.16.432.336.432.528 0 .16-.064.304-.192.432-.992.992-1.84 3.104-2.544 6.336a47.745 47.745 0 00-1.008 9.744c0 3.264.32 5.904.96 7.92.672 2.016 1.68 3.024 3.024 3.024 2.304 0 5.008-3.168 8.112-9.504a54.506 54.506 0 003.6-9.6c.96-3.424 1.44-6.24 1.44-8.448zM49.373 6.6c0 .416-.304.944-.912 1.584-.608.64-.992 1.136-1.152 1.488-.416 1.056-.864 1.648-1.344 1.776-.64 0-.96-.528-.96-1.584 0-.672.496-1.408 1.488-2.208.992-.8 1.856-1.2 2.592-1.2.16 0 .256.048.288.144zm-7.728 14.064l-.144-.624c0-.128.192-.768.576-1.92.416-1.152.896-2.064 1.44-2.736.544-.672 1.344-1.008 2.4-1.008.416 0 .656.144.72.432-.512.8-1.2 2.128-2.064 3.984-.832 1.856-1.424 3.232-1.776 4.128-.832 2.08-1.536 4.4-2.112 6.96a1.249 1.249 0 00-.048.384c0 .384.16.576.48.576.192 0 .704-.24 1.536-.72.864-.48 1.408-.72 1.632-.72.256 0 .4.064.432.192 0 .384-.816 1.104-2.448 2.16-1.632 1.024-2.752 1.536-3.36 1.536-.608 0-.912-.288-.912-.864 0-.288.112-.768.336-1.44.256-.704.56-1.584.912-2.64.384-1.056.672-1.872.864-2.448.192-.576.384-1.168.576-1.776.224-.608.384-1.056.48-1.344.096-.32.192-.624.288-.912.128-.576.192-.976.192-1.2zM57.195 15.048c2.688 0 4.032.304 4.032.912 0 .704-.192 1.248-.576 1.632-.352.384-.656.608-.912.672-.224.064-.336.112-.336.144-1.6 1.312-3.728 3.312-6.384 6-2.624 2.656-4.448 4.752-5.472 6.288-.064.064-.096.16-.096.288 0 .512 1.328.768 3.984.768 2.688 0 4.928-.224 6.72-.672a3.04 3.04 0 01.864-.144c.288 0 .432.16.432.48 0 .32-.192.752-.576 1.296-.384.512-.8.768-1.248.768-.416 0-.624-.16-.624-.48-1.92-.16-3.472-.24-4.656-.24-1.184 0-2.512.064-3.984.192-1.44.096-2.272.144-2.496.144-.8 0-1.2-.4-1.2-1.2 0-.8.304-1.472.912-2.016 5.568-5.376 9.76-9.76 12.576-13.152h-2.592c-2.496 0-3.952.224-4.368.672-.032.032-.176.208-.432.528-.704.864-1.104 1.296-1.2 1.296-.288 0-.432-.112-.432-.336 0-1.344.352-2.304 1.056-2.88.736-.608 2.016-.912 3.84-.912l3.168-.048zM108.984 3.576l-.096-1.824c0-.576.32-.864.96-.864.96 0 1.44.976 1.44 2.928s-.624 4.784-1.872 8.496c-1.248 3.712-2.528 6.896-3.84 9.552-1.76 3.68-3.632 6.464-5.616 8.352C97.976 32.072 96.264 33 94.824 33c-1.824 0-3.168-1.104-4.032-3.312-.832-2.208-1.248-5.088-1.248-8.64 0-1.152.048-2.304.144-3.456-1.056 2.848-2.256 5.36-3.6 7.536-1.312 2.144-2.576 3.744-3.792 4.8-2.336 2.08-4.272 3.12-5.808 3.12-1.504 0-2.624-.848-3.36-2.544-.736-1.696-1.104-3.952-1.104-6.768 0-5.568 1.008-11.232 3.024-16.992-.192-.032-.288-.256-.288-.672 0-.448.272-1.2.816-2.256.544-1.088.976-1.776 1.296-2.064.608-.48 1.184-.72 1.728-.72 1.024 0 1.536.272 1.536.816 0 .16-.064.304-.192.432-1.152 1.056-2.208 3.248-3.168 6.576-.96 3.328-1.6 6.384-1.92 9.168-.32 2.784-.48 4.896-.48 6.336 0 4.512 1.12 6.768 3.36 6.768 1.216 0 2.976-1.312 5.28-3.936 1.152-1.312 2.368-3.184 3.648-5.616 1.312-2.432 2.48-5.168 3.504-8.208.352-2.624.8-4.816 1.344-6.576-.288-.096-.432-.32-.432-.672 0-.992.352-1.776 1.056-2.352.736-.608 1.36-.912 1.872-.912s.896.096 1.152.288c.288.16.432.336.432.528 0 .16-.064.304-.192.432-.992.992-1.84 3.104-2.544 6.336a47.745 47.745 0 00-1.008 9.744c0 3.264.32 5.904.96 7.92.672 2.016 1.68 3.024 3.024 3.024 2.304 0 5.008-3.168 8.112-9.504a54.506 54.506 0 003.6-9.6c.96-3.424 1.44-6.24 1.44-8.448zM122.437 18.696c.608.096.912.288.912.576 0 .256-.24.496-.72.72-.48.224-.912.336-1.296.336 0 3.744-.976 6.944-2.928 9.6-1.952 2.656-3.888 3.984-5.808 3.984-1.856 0-2.784-1.344-2.784-4.032 0-2.368.896-5.6 2.688-9.696.672-1.536 1.488-2.832 2.448-3.888.992-1.088 1.984-1.632 2.976-1.632h.336c0-.448.128-.832.384-1.152.256-.32.608-.48 1.056-.48.448.032.848.976 1.2 2.832.352 1.824.864 2.768 1.536 2.832zm-2.448 1.248c-.288-.16-.64-.72-1.056-1.68-.416-.992-.704-1.488-.864-1.488-.992 0-2.144 1.472-3.456 4.416-1.312 2.912-2.08 4.976-2.304 6.192-.224 1.216-.336 2.128-.336 2.736 0 1.568.448 2.352 1.344 2.352 1.28 0 2.704-1.296 4.272-3.888 1.6-2.624 2.4-5.504 2.4-8.64zM124.776 20.712l-.192-.816c0-.192.032-.368.096-.528.512-2.016 1.024-3.392 1.536-4.128.544-.736 1.328-1.104 2.352-1.104.384 0 .608.128.672.384-.032.096-.272.656-.72 1.68-.416 1.024-.8 1.984-1.152 2.88-.992 2.4-1.76 4.8-2.304 7.2 1.056-2.08 2.688-4.576 4.896-7.488 2.208-2.944 4.032-4.416 5.472-4.416.768 0 1.152.496 1.152 1.488 0 .96-.368 1.952-1.104 2.976-.256.352-.608.704-1.056 1.056-.416.32-.736.48-.96.48-.192 0-.288-.08-.288-.24 0-.16.144-.624.432-1.392.32-.768.48-1.28.48-1.536s-.08-.384-.24-.384c-1.12 0-2.784 1.728-4.992 5.184-2.176 3.456-3.792 6.832-4.848 10.128-.192.256-.496.512-.912.768-.416.256-.752.384-1.008.384-.224 0-.384-.08-.48-.24 0-.864.096-1.648.288-2.352.224-.704.496-1.12.816-1.248.704-2.656 1.2-4.64 1.488-5.952l.48-2.016a2.8 2.8 0 00.096-.768zM142.322 8.952l-.144-.624c0-.128.208-.768.624-1.92.416-1.184.88-2.096 1.392-2.736.512-.672 1.296-1.008 2.352-1.008.448 0 .688.144.72.432-1.92 3.872-3.488 7.344-4.704 10.416-1.184 3.072-2.24 6.464-3.168 10.176l2.208-1.968a459.67 459.67 0 017.344-6.432c.864-.64 1.456-.96 1.776-.96.32 0 .48.064.48.192 0 .352-.432.864-1.296 1.536-1.984 1.152-3.872 2.704-5.664 4.656-1.76 1.92-2.64 3.184-2.64 3.792 0 1.152.496 2.592 1.488 4.32.992 1.728 1.824 2.88 2.496 3.456.704.576 1.056 1.024 1.056 1.344 0 .192-.144.288-.432.288-.64 0-1.376-.432-2.208-1.296-1.248-1.344-2.576-3.296-3.984-5.856l-1.008-1.776c-1.376 3.808-2.096 6.208-2.16 7.2 0 .224-.304.576-.912 1.056-.576.512-1.04.768-1.392.768-.224 0-.336-.144-.336-.432 0-.128.08-.432.24-.912 1.376-3.424 2.864-7.696 4.464-12.816 1.632-5.152 2.608-8.208 2.928-9.168.32-.96.48-1.536.48-1.728z"
                  fill="#000"
                />
                <path
                  d="M160.924 16.536c-.064.64-.48 1.552-1.248 2.736-.768 1.184-1.36 1.776-1.776 1.776-.128 0-.192-.112-.192-.336 0-.256.176-.816.528-1.68.352-.896.528-1.472.528-1.728 0-.48-.288-.72-.864-.72-.096 0-.624.08-1.584.24-.8.192-1.856.704-3.168 1.536-1.28.832-1.92 1.744-1.92 2.736 0 .352.08.672.24.96.416.832 1.136 1.536 2.16 2.112a29.46 29.46 0 012.688 1.632c.768.512 1.152 1.184 1.152 2.016 0 1.408-1.088 2.768-3.264 4.08-2.144 1.28-3.984 1.92-5.52 1.92-.256 0-.464-.112-.624-.336a.956.956 0 01-.24-.624c0-.384.176-.576.528-.576 1.056 0 2.528-.32 4.416-.96 1.92-.672 2.88-1.392 2.88-2.16 0-.8-1.136-1.888-3.408-3.264a13.195 13.195 0 01-2.4-1.824c-.704-.736-1.056-1.408-1.056-2.016 0-.608.16-1.12.48-1.536.352-.416.688-.784 1.008-1.104.32-.352.624-.656.912-.912.288-.256.608-.512.96-.768l1.008-.672a9.414 9.414 0 011.008-.576l.912-.48c.672-.32 1.152-.528 1.44-.624.288-.096.592-.208.912-.336.736-.288 1.328-.432 1.776-.432 1.152 0 1.728.64 1.728 1.92z"
                  fill="#000"
                />
              </svg>
            </div>

            <nav className="desktop-links">
              <ul className="page-nav">
                <li>
                  <a href="#!">Welcome</a>
                </li>
                <li>
                  <a href="#services">Services</a>
                </li>
                <li>
                  <a href="#slogan">About</a>
                </li>
                <li>
                  <a href="#kudos">Kudos</a>
                </li>
                <li>
                  <a href="#contact">Contact</a>
                </li>
              </ul>
            </nav>

            <div style={{ flex: "0 0 8%" }}></div>
          </div>
        </div>
      </StickyDiv>
      <Sidebar open={navDrawerOpen} closeHandler={closeNavDrawer}></Sidebar>
    </>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
